require('./bootstrap');

import Vue from 'vue'

import Alpine from 'alpinejs';

window.Alpine = Alpine;

Alpine.start();

import Carousel from './components/global/Carousel'
import Paginate from './components/global/Paginate'
import AccessibilityComponent from './components/AccessibilityComponent'
import ContactUsComponent from './components/ContactUsComponent'
import SearchComponent from './components/SearchComponent'
import CardSearchComponent from './components/CardSearchComponent'
import SearchPageComponent from './components/SearchPageComponent'
import AgendaHighlightsComponent from './components/AgendaHighlightsComponent'
import BannerComponent from './components/BannerComponent'
import NewsComponent from './components/NewsComponent'
import NoteComponent from './components/NoteComponent'
import NewsResumeComponent from './components/NewsResumeComponent'
import DocumentComponent from './components/DocumentComponent'
import AgendaPageComponent from './components/agendaPage/indexAgenda'
import NotePageComponent from './components/notePage/indexNote'
import DocumentPageComponent from './components/documentPage/index'


/* Mobile Check */
const navbar = document.getElementById("menu")
const menuButtons = document.getElementById("menu-buttons")
const mainContainer = document.getElementById("main-container")
const menuTitle = document.getElementById("menu-title")
const sticky = navbar.offsetTop

function fixedNavbar() {
  if (window.pageYOffset >= sticky && window.innerWidth < 768) {
    navbar.classList.add("fixed", "top-0", "right-0", "left-0", "bg-default-500","px-4", "shadow")
    menuButtons.classList.remove("shadow", "bg-default-400")
    mainContainer.classList.add('mt-14')
    menuTitle.innerHTML = 'Prefeitura de Santarém'
  } else {
    navbar.classList.remove("fixed", "top-0", "right-0", "left-0", "bg-default-500","px-4", "shadow");
    menuButtons.classList.add("shadow",  "bg-default-400")
    mainContainer.classList.remove('mt-14');
    menuTitle.innerHTML = 'Menu'
  }
}

function autoColumn() {
  let flexible_column = document.querySelector('.flexible-column');
  let auto_column = document.querySelector('.auto-column');
  if(flexible_column && auto_column) {
    auto_column.style.height = flexible_column.offsetHeight + 'px';
  }
}

window.onscroll = () =>fixedNavbar()

if(window.innerWidth >= 768) {
  autoColumn()
}

onresize = (event) => {
  if(window.innerWidth >= 768) {
     autoColumn()
     let flexible_column = document.querySelector('.flexible-column');
     console.log(flexible_column.offsetHeight + 'px');
  }
};

var Contrast = {
  storage: 'contrastState',
  cssClass: 'contrast',
  currentState: null,
  check: checkContrast,
  getState: getContrastState,
  setState: setContrastState,
  toogle: toogleContrast,
  updateView: updateViewContrast
}

window.toggleContrast = function () {
  Contrast.toogle()
}

Contrast.check()

let elements = document.querySelectorAll('button, label, p, h1, h2, h3, h4, h5, h6, span, small, strong, li, a');
elements.forEach((item) => {
  let style = window.getComputedStyle(item)
  let fontSize = parseFloat(style.getPropertyValue('font-size'));
  let size = parseFloat(localStorage.getItem('font-size'));
  item.style.fontSize = (fontSize + size) + 'px'
});

window.changeFont = function (decreasesFont = false) {
  let elements = document.querySelectorAll('button, label, p, h1, h2, h3, h4, h5, h6, span, small, strong, li, a');
  elements.forEach((item) => {
    let style = window.getComputedStyle(item)
    let fontSize = parseFloat(style.getPropertyValue('font-size'))
    if (decreasesFont) {
      item.style.fontSize = (fontSize - 1) + 'px'
    } else {
      item.style.fontSize = (fontSize + 1) + 'px'
    }
  })

  let size = Number(localStorage.getItem('font-size'))
  size = decreasesFont ? size - 1 : size + 1
  localStorage.setItem('font-size', size)
}

function checkContrast() {
  this.updateView()
}

function getContrastState() {
  return localStorage.getItem(this.storage) === 'true'
}

function setContrastState(state) {
  localStorage.setItem(this.storage, '' + state)
  this.currentState = state
  this.updateView()
}

function updateViewContrast() {
  var body = document.body

  if (this.currentState === null) {
    this.currentState = this.getState()
  }
  if (this.currentState) {
    body.classList.add(this.cssClass)
  } else {
    body.classList.remove(this.cssClass)
  }
}

function toogleContrast() {
  this.setState(!this.currentState)
}

const app = new Vue({
  el: '#app',
  components: {
    AccessibilityComponent,
    ContactUsComponent,
    SearchComponent,
    CardSearchComponent,
    SearchPageComponent,
    AgendaHighlightsComponent,
    AgendaPageComponent,
    BannerComponent,
    Carousel,
    NewsComponent,
    NoteComponent,
    NewsResumeComponent,
    DocumentComponent,
    Paginate,
    DocumentPageComponent,
    NotePageComponent
  },
});
